import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-teal-soft px-4 py-16 sm:py-24" data-id="element-136" data-mp="122vbicn8knnw">
      <SectionHeading title="Frequently Asked Questions" data-id="element-137" data-mp="1prxw9td62wmm" />
      <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-138" data-mp="1puk31qs8h83s">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy/10" data-id="element-139" data-mp="1g1cvbza0tg0j" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-display text-lg font-semibold leading-snug text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-teal sm:px-6" data-id="element-140" data-mp="1l0fvb5b58w1n">
                {f.q}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-teal transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-141" data-mp="2jpb3tsypgn1r" />
              </button>
              <AnimatePresence initial={false} data-id="element-142" data-mp="37fx8rbdexr7j">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-143" data-mp="32i589sypcwrq">
                    <p className="px-5 pb-5 text-base leading-relaxed text-ink-soft sm:px-6" data-id="element-144" data-mp="1n0d7i6bb4h2h">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
      <CtaButton label="Get the complete system for $27" className="mt-10" data-id="element-145" data-mp="27r91hz96g5xp" />
    </section>;
}